import {
  generateGuestLocationEndPoint,
  generateOwnerLocationEndPoint,
  LocationDetails,
  useAppQuery,
} from '@alluradirect/react';

const select = (data: any) => data?.DATA;

interface Args {
  enabled?: boolean;
  isOwnerApp: boolean;
  guestId: number;
}

export const useLocationDetails = ({ enabled = true, isOwnerApp, guestId }: Args) => {
  const endpoint = isOwnerApp ? generateOwnerLocationEndPoint() : generateGuestLocationEndPoint(guestId);

  return useAppQuery<LocationDetails>({
    endpoint,
    enabled,
    select,
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
